import { useChartSettingsQueries } from "./useChartSettingsQueries"

export const useChartSettings = ({recipeId}) =>
{
    const {chartSettingsQuery} = useChartSettingsQueries({recipeId});
    return {chartSettingsQuery}
}